<div class="container-fluid h-100 p-md-1">
    <div class="row align-items-center my-2">
        <table #table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="InvoiceELE">
                <th mat-header-cell *matHeaderCellDef > Société</th>
                <td mat-cell #primary *matCellDef="let element"> {{element.InvoiceELE}}</td>
            </ng-container>

            <ng-container matColumnDef="ClientName">
                <th mat-header-cell *matHeaderCellDef > Agence</th>
                <td mat-cell #primary *matCellDef="let element"> {{element.ClientName}}</td>
            </ng-container>

            <ng-container matColumnDef="InvoiceCode">
                <th mat-header-cell *matHeaderCellDef > N° de facture</th>
                <td mat-cell #primary *matCellDef="let element"> {{element.InvoiceCode}}</td>
            </ng-container>

            <ng-container matColumnDef="InvoiceDate">
                <th mat-header-cell *matHeaderCellDef > Date</th>
                <td mat-cell #primary *matCellDef="let element"> {{element.InvoiceDate |date}}</td>
            </ng-container>

            <ng-container matColumnDef="InvoiceAmount">
                <th mat-header-cell *matHeaderCellDef > Montant (€)</th>
                <td mat-cell #primary *matCellDef="let element"> {{element.InvoiceAmount}}</td>
            </ng-container>
            <ng-container matColumnDef="Comment">
                <th mat-header-cell *matHeaderCellDef > Note</th>
                <td mat-cell #primary *matCellDef="let element">   <mat-icon  class="material-symbols-outlined" [matTooltip]="element.Comment" *ngIf="element.Comment">sticky_note_2</mat-icon> </td>
            </ng-container>
            <ng-container matColumnDef="InvoicePurchaseOrder">
                <th mat-header-cell *matHeaderCellDef > N° De Bon de Commande</th>
                <td mat-cell #primary *matCellDef="let element"> 
                    <div  *ngIf="!element.InvoicePurchaseOrder">
                        <mat-form-field style="margin-right: 10px;" ><input matInput color="warn" [(ngModel)]="element.tempInvoicePurchaseOrder"   [placeholder]="element.Placeholder"  [pattern]="element.Pattern" ></mat-form-field> 
                        <button mat-mini-fab extended (click)="setPO (element)" [disabled]="!isPurchaseOrderValid(element.Pattern,element.tempInvoicePurchaseOrder) ? 'disabled': null">
                            <mat-icon  class="material-symbols-outlined" >done</mat-icon>
                        </button>
                    </div>
                    <div  *ngIf="element.InvoicePurchaseOrder">
                        {{element.InvoicePurchaseOrder}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="InvoiceExcelFile">
                <th mat-header-cell *matHeaderCellDef > Fichier de synthèse</th>
                <td mat-cell #primary *matCellDef="let element"> 
                    <div>
                    <span style="margin-right: 10px;" >{{element.InvoiceExcelFile}}</span>
                    <button mat-mini-fab extended (click)="downLoadDocument(element.InvoiceCode)" >
                        <mat-icon  class="material-symbols-outlined">download</mat-icon>
                    </button>
                </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable"></tr>

        </table>
    </div>

</div>
